import { defineComponent, computed } from '@vue/composition-api';
import { PasswordStrength } from './PasswordStrength.js';

var script = defineComponent({
    name: 'SdsPasswordStrength',
    props: {
        passwordStrength: {
            type: [Number, String],
            required: true,
        },
    },
    setup: function (props) {
        var currentPercentageValue = computed(function () {
            switch (props.passwordStrength) {
                case PasswordStrength.None:
                    return 0;
                case PasswordStrength.Weak:
                    return 33;
                case PasswordStrength.Medium:
                    return 75;
                case PasswordStrength.Strong:
                    return 100;
                default:
                    return 0;
            }
        });
        return {
            currentPercentageValue: currentPercentageValue,
        };
    },
});

export default script;
